// // import React, { useState, useEffect, useRef } from "react";
// // import EntityManagement from "../../components/formTemplates/EntityManagement";
// // import EntityTable from "../../components/templateComponents/EntityTable";
// // import useDropdownFetch from "../../components/apiFetch/useDropdownFetch";
// // import axiosInstance from "../../utils/axios";

// // const Establishments = () => {
// //   const [formData, setFormData] = useState({
// //     est_name: "",
// //     country_id: "",
// //     state_id: "",
// //     csc_id: "",
// //     area_id: "",
// //     phone_extension: "",
// //     phone_no: "",
// //     status_id: "",
// //     logo: null,
// //   });

// //   const [entities, setEntities] = useState([]);
// //   const [dropdownData, setDropdownData] = useState({
// //     country_id: [],
// //     state_id: [],
// //     csc_id: [],
// //     area_id: [],
// //     status_id: [],
// //   });

// //   const [editMode, setEditMode] = useState(false);
// //   const [editingEntityId, setEditingEntityId] = useState(null);
// //   const [isTableModalOpen, setIsTableModalOpen] = useState(false);
// //   const firstFormFieldRef = useRef(null);

// //   const endpoints = {
// //     country: "/country/v0.1",
// //     state: "/state/v0.1",
// //     csc: "/city/v0.1",
// //     area: "/area/v0.1",
// //     status: "/view_status/v0.1",
// //     viewEstablishments: "/view_establishment/v1.1",
// //     registerEstablishment: "/registration_establishment/v1.1",
// //     updateEstablishment: "/update_establishment/v1.1",
// //   };

// //   const { options: statusOptions } = useDropdownFetch(endpoints.status);

// //   useEffect(() => {
// //     const fetchCountries = async () => {
// //       try {
// //         const response = await axiosInstance.get(endpoints.country);
// //         const formatted = Object.entries(response.data.Data).map(
// //           ([value, label]) => ({
// //             value,
// //             label,
// //           })
// //         );
// //         setDropdownData((prev) => ({ ...prev, country_id: formatted }));
// //       } catch (error) {
// //         console.error("Error fetching countries:", error);
// //       }
// //     };

// //     fetchCountries();
// //   }, []);

// //   useEffect(() => {
// //     const fetchStates = async () => {
// //       if (!formData.country_id) return;
// //       try {
// //         const response = await axiosInstance.post(endpoints.state, {
// //           csc_id: formData.country_id,
// //         });
// //         const formatted = Object.entries(response.data.Data).map(
// //           ([value, label]) => ({
// //             value,
// //             label,
// //           })
// //         );
// //         setDropdownData((prev) => ({ ...prev, state_id: formatted }));
// //       } catch (error) {
// //         console.error("Error fetching states:", error);
// //       }
// //     };

// //     fetchStates();
// //   }, [formData.country_id]);

// //   useEffect(() => {
// //     const fetchCities = async () => {
// //       if (!formData.state_id) return;
// //       try {
// //         const response = await axiosInstance.post(endpoints.csc, {
// //           csc_id: formData.state_id,
// //           view_type: "view",
// //         });
// //         const formatted = Object.entries(response.data.Data).map(
// //           ([value, label]) => ({
// //             value,
// //             label,
// //           })
// //         );
// //         setDropdownData((prev) => ({ ...prev, csc_id: formatted }));
// //       } catch (error) {
// //         console.error("Error fetching cities:", error);
// //       }
// //     };

// //     fetchCities();
// //   }, [formData.state_id]);

// //   useEffect(() => {
// //     const fetchAreas = async () => {
// //       if (!formData.csc_id) return;
// //       try {
// //         const response = await axiosInstance.post(endpoints.area, {
// //           csc_id: formData.csc_id,
// //           view_type: "view",
// //         });
// //         const formatted = Object.entries(response.data.Data).map(
// //           ([value, label]) => ({
// //             value,
// //             label,
// //           })
// //         );
// //         setDropdownData((prev) => ({ ...prev, area_id: formatted }));
// //       } catch (error) {
// //         console.error("Error fetching areas:", error);
// //       }
// //     };

// //     fetchAreas();
// //   }, [formData.csc_id]);

// //   useEffect(() => {
// //     if (statusOptions) {
// //       setDropdownData((prev) => ({
// //         ...prev,
// //         status_id: statusOptions,
// //       }));
// //     }
// //   }, [statusOptions]);

// //   useEffect(() => {
// //     const fetchEntities = async () => {
// //       try {
// //         const response = await axiosInstance.post(
// //           endpoints.viewEstablishments,
// //           {
// //             view_type: "view all",
// //           }
// //         );
// //         setEntities(response.data.Data || []);
// //       } catch (error) {
// //         console.error("Error fetching establishments:", error);
// //       }
// //     };

// //     fetchEntities();
// //   }, [formData.area_id]);

// //   const handleUpdate = async (entityId, updatedData) => {
// //     try {
// //       await axiosInstance.post(endpoints.updateEstablishment, {
// //         est_id: entityId,
// //         ...updatedData,
// //       });

// //       setEntities((prev) =>
// //         prev.map((entity) =>
// //           entity.est_id === entityId
// //             ? { ...updatedData, est_id: entityId }
// //             : entity
// //         )
// //       );
// //       resetForm();
// //     } catch (error) {
// //       console.error("Error updating establishment:", error);
// //     }
// //   };

// //   const handleFormSubmit = async (e) => {
// //     e.preventDefault();

// //     const formattedFormData = {};
// //     Object.entries(formData).forEach(([key, value]) => {
// //       if (value !== "" && value !== null && value !== undefined) {
// //         formattedFormData[key] = value;
// //       }
// //     });

// //     // Parse integers for expected fields
// //     ["csc_id", "area_id", "status_id"].forEach((key) => {
// //       if (formattedFormData[key]) {
// //         formattedFormData[key] = parseInt(formattedFormData[key], 10);
// //       }
// //     });

// //     // Remove country/state from payload
// //     delete formattedFormData.country_id;
// //     delete formattedFormData.state_id;

// //     const { logo } = formData;

// //     try {
// //       if (editMode) {
// //         await handleUpdate(editingEntityId, formattedFormData);
// //       } else {
// //         let response;
// //         if (logo) {
// //           const formDataToSubmit = new FormData();
// //           for (const key in formattedFormData) {
// //             formDataToSubmit.append(key, formattedFormData[key]);
// //           }
// //           formDataToSubmit.append("logo", logo);

// //           response = await axiosInstance.post(
// //             endpoints.registerEstablishment,
// //             formDataToSubmit
// //           );
// //         } else {
// //           response = await axiosInstance.post(
// //             endpoints.registerEstablishment,
// //             formattedFormData
// //           );
// //         }
// //         setEntities([...entities, response.data]);
// //         resetForm();
// //       }
// //     } catch (error) {
// //       console.error("Error submitting form:", error);
// //     }
// //   };

// //   const resetForm = () => {
// //     setFormData({
// //       est_name: "",
// //       country_id: "",
// //       state_id: "",
// //       csc_id: "",
// //       area_id: "",
// //       phone_extension: "",
// //       phone_no: "",
// //       status_id: "",
// //       logo: null,
// //     });
// //     setEditMode(false);
// //     setEditingEntityId(null);
// //   };

// //   const handleEdit = (entityId) => {
// //     const entity = entities.find((e) => e.est_id === entityId);
// //     if (entity) {
// //       setFormData({
// //         est_name: entity.est_name,
// //         csc_id: entity.csc_id,
// //         area_id: entity.area_id,
// //         phone_extension: entity.phone_extension,
// //         phone_no: entity.phone_no,
// //         status_id: entity.status_id,
// //         logo: null,
// //         country_id: "", // Keep these blank during edit
// //         state_id: "",
// //       });
// //       setEditMode(true);
// //       setEditingEntityId(entityId);
// //       firstFormFieldRef.current?.focus();
// //       setIsTableModalOpen(false);
// //     }
// //   };

// //   const handleDelete = async (entityId) => {
// //     const entity = entities.find((e) => e.est_id === entityId);
// //     if (!entity) return;

// //     try {
// //       const response = await axiosInstance.post(endpoints.updateEstablishment, {
// //         ...entity,
// //         status_id: 3,
// //       });

// //       if (response.data.Status === "Success") {
// //         setEntities((prev) => prev.filter((e) => e.est_id !== entityId));
// //       }
// //     } catch (error) {
// //       console.error("Error deleting establishment:", error);
// //     }
// //   };

// //   const handleFileChange = (e) => {
// //     setFormData({ ...formData, logo: e.target.files[0] });
// //   };

// //   const formFields = [
// //     { name: "est_name", label: "Establishment Name", type: "text" },
// //     {
// //       name: "country_id",
// //       label: "Country",
// //       type: "select",
// //       dropdownKey: "country_id",
// //     },
// //     {
// //       name: "state_id",
// //       label: "State",
// //       type: "select",
// //       dropdownKey: "state_id",
// //     },
// //     { name: "csc_id", label: "City", type: "select", dropdownKey: "csc_id" },
// //     { name: "area_id", label: "Area", type: "select", dropdownKey: "area_id" },
// //     { name: "phone_extension", label: "Phone Extension", type: "text" },
// //     { name: "phone_no", label: "Phone Number", type: "text" },
// //     {
// //       name: "status_id",
// //       label: "Status",
// //       type: "select",
// //       dropdownKey: "status_id",
// //     },
// //     { name: "logo", label: "Logo", type: "file", onChange: handleFileChange },
// //   ];

// //   const columns = [
// //     { name: "est_name", label: "Name" },
// //     { name: "csc_name", label: "City" },
// //     { name: "area_name", label: "Area" },
// //     { name: "phone_extension", label: "Phone Extension" },
// //     { name: "phone_no", label: "Phone No" },
// //     { name: "status_name", label: "Status" },
// //     { name: "logo", label: "Logo" },
// //   ];

// //   return (
// //     <div className="establishments">
// //       <EntityManagement
// //         entityName="Establishment"
// //         formFields={formFields}
// //         formData={formData}
// //         onFileChange={handleFileChange}
// //         setFormData={setFormData}
// //         handleFormSubmit={handleFormSubmit}
// //         dropdownData={dropdownData}
// //         setDropdownData={setDropdownData}
// //         handleViewTableClick={() => setIsTableModalOpen(true)}
// //         firstFormFieldRef={firstFormFieldRef}
// //         onEdit={handleEdit}
// //       />
// //       {isTableModalOpen && (
// //         <div className="modal">
// //           <div className="modal-content">
// //             <button onClick={() => setIsTableModalOpen(false)}>Close</button>
// //             <EntityTable
// //               data={entities}
// //               columns={columns}
// //               onEdit={handleEdit}
// //               onDelete={handleDelete}
// //               keyField="est_id"
// //             />
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default Establishments;


// import React, { useState, useEffect, useRef } from "react";
// import EntityManagement from "../../components/formTemplates/EntityManagement";
// import EntityTable from "../../components/templateComponents/EntityTable";
// import useDropdownFetch from "../../components/apiFetch/useDropdownFetch";
// import axiosInstance from "../../utils/axios";

// const Establishments = () => {
//   const [formData, setFormData] = useState({
//     est_name: "",
//     country_id: "",
//     state_id: "",
//     csc_id: "",
//     area_id: "",
//     phone_extension: "",
//     phone_no: "",
//     status_id: "",
//     logo: null,
//   });

//   const [entities, setEntities] = useState([]);
//   const [dropdownData, setDropdownData] = useState({
//     country_id: [],
//     state_id: [],
//     csc_id: [],
//     area_id: [],
//     status_id: [],
//     phone_extension: [
//       { value: "+91", label: "+91" },
//       { value: "+1", label: "+1" },
//       { value: "+44", label: "+44" },
//       { value: "+61", label: "+61" },
//       { value: "+81", label: "+81" },
//     ],
//   });

//   const [editMode, setEditMode] = useState(false);
//   const [editingEntityId, setEditingEntityId] = useState(null);
//   const [isTableModalOpen, setIsTableModalOpen] = useState(false);
//   const firstFormFieldRef = useRef(null);

//   const endpoints = {
//     country: "/country/v0.1",
//     state: "/state/v0.1",
//     csc: "/city/v0.1",
//     area: "/area/v0.1",
//     status: "/view_status/v0.1",
//     viewEstablishments: "/view_establishment/v1.1",
//     registerEstablishment: "/registration_establishment/v1.1",
//     updateEstablishment: "/update_establishment/v1.1",
//   };

//   const { options: statusOptions } = useDropdownFetch(endpoints.status);

//   useEffect(() => {
//     const fetchCountries = async () => {
//       try {
//         const response = await axiosInstance.get(endpoints.country);
//         const formatted = Object.entries(response.data.Data).map(
//           ([value, label]) => ({ value, label })
//         );
//         setDropdownData((prev) => ({ ...prev, country_id: formatted }));
//       } catch (error) {
//         console.error("Error fetching countries:", error);
//       }
//     };
//     fetchCountries();
//   }, []);

//   useEffect(() => {
//     const fetchStates = async () => {
//       if (!formData.country_id) return;
//       try {
//         const response = await axiosInstance.post(endpoints.state, {
//           csc_id: formData.country_id,
//         });
//         const formatted = Object.entries(response.data.Data).map(
//           ([value, label]) => ({ value, label })
//         );
//         setDropdownData((prev) => ({ ...prev, state_id: formatted }));
//       } catch (error) {
//         console.error("Error fetching states:", error);
//       }
//     };
//     fetchStates();
//   }, [formData.country_id]);

//   useEffect(() => {
//     const fetchCities = async () => {
//       if (!formData.state_id) return;
//       try {
//         const response = await axiosInstance.post(endpoints.csc, {
//           csc_id: formData.state_id,
//           view_type: "view",
//         });
//         const formatted = Object.entries(response.data.Data).map(
//           ([value, label]) => ({ value, label })
//         );
//         setDropdownData((prev) => ({ ...prev, csc_id: formatted }));
//       } catch (error) {
//         console.error("Error fetching cities:", error);
//       }
//     };
//     fetchCities();
//   }, [formData.state_id]);

//   useEffect(() => {
//     const fetchAreas = async () => {
//       if (!formData.csc_id) return;
//       try {
//         const response = await axiosInstance.post(endpoints.area, {
//           csc_id: formData.csc_id,
//           view_type: "view",
//         });
//         const formatted = Object.entries(response.data.Data).map(
//           ([value, label]) => ({ value, label })
//         );
//         setDropdownData((prev) => ({ ...prev, area_id: formatted }));
//       } catch (error) {
//         console.error("Error fetching areas:", error);
//       }
//     };
//     fetchAreas();
//   }, [formData.csc_id]);

//   useEffect(() => {
//     if (statusOptions) {
//       setDropdownData((prev) => ({
//         ...prev,
//         status_id: statusOptions,
//       }));
//     }
//   }, [statusOptions]);

//   useEffect(() => {
//     const fetchEntities = async () => {
//       try {
//         const response = await axiosInstance.post(endpoints.viewEstablishments, {
//           view_type: "view all",
//         });
//         setEntities(response.data.Data || []);
//       } catch (error) {
//         console.error("Error fetching establishments:", error);
//       }
//     };
//     fetchEntities();
//   }, [formData.area_id]);

//   const handleUpdate = async (entityId, updatedData) => {
//     try {
//       await axiosInstance.post(endpoints.updateEstablishment, {
//         est_id: entityId,
//         ...updatedData,
//       });
//       setEntities((prev) =>
//         prev.map((entity) =>
//           entity.est_id === entityId ? { ...updatedData, est_id: entityId } : entity
//         )
//       );
//       resetForm();
//     } catch (error) {
//       console.error("Error updating establishment:", error);
//     }
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     const formattedFormData = {};
//     Object.entries(formData).forEach(([key, value]) => {
//       if (value !== "" && value !== null && value !== undefined) {
//         formattedFormData[key] = value;
//       }
//     });

//     ["csc_id", "area_id", "status_id"].forEach((key) => {
//       if (formattedFormData[key]) {
//         formattedFormData[key] = parseInt(formattedFormData[key], 10);
//       }
//     });

//     delete formattedFormData.country_id;
//     delete formattedFormData.state_id;

//     try {
//       if (editMode) {
//         await handleUpdate(editingEntityId, formattedFormData);
//       } else {
//         let response;
//         if (formData.logo) {
//           const formDataToSubmit = new FormData();
//           for (const key in formattedFormData) {
//             formDataToSubmit.append(key, formattedFormData[key]);
//           }
//           formDataToSubmit.append("logo", formData.logo);
//           response = await axiosInstance.post(
//             endpoints.registerEstablishment,
//             formDataToSubmit
//           );
//         } else {
//           response = await axiosInstance.post(
//             endpoints.registerEstablishment,
//             formattedFormData
//           );
//         }
//         setEntities([...entities, response.data]);
//         resetForm();
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       est_name: "",
//       country_id: "",
//       state_id: "",
//       csc_id: "",
//       area_id: "",
//       phone_extension: "",
//       phone_no: "",
//       status_id: "",
//       logo: null,
//     });
//     setEditMode(false);
//     setEditingEntityId(null);
//   };

//   const handleEdit = (entityId) => {
//     const entity = entities.find((e) => e.est_id === entityId);
//     if (entity) {
//       setFormData({
//         est_name: entity.est_name,
//         csc_id: entity.csc_id,
//         area_id: entity.area_id,
//         phone_extension: entity.phone_extension,
//         phone_no: entity.phone_no,
//         status_id: entity.status_id,
//         logo: null,
//         country_id: "",
//         state_id: "",
//       });
//       setEditMode(true);
//       setEditingEntityId(entityId);
//       firstFormFieldRef.current?.focus();
//       setIsTableModalOpen(false);
//     }
//   };

//   const handleDelete = async (entityId) => {
//     const entity = entities.find((e) => e.est_id === entityId);
//     if (!entity) return;
//     try {
//       const response = await axiosInstance.post(endpoints.updateEstablishment, {
//         ...entity,
//         status_id: 3,
//       });
//       if (response.data.Status === "Success") {
//         setEntities((prev) => prev.filter((e) => e.est_id !== entityId));
//       }
//     } catch (error) {
//       console.error("Error deleting establishment:", error);
//     }
//   };

//   const handleFileChange = (e) => {
//     setFormData({ ...formData, logo: e.target.files[0] });
//   };

//   const formFields = [
//     { name: "est_name", label: "Establishment Name", type: "text" },
//     { name: "country_id", label: "Country", type: "select", dropdownKey: "country_id" },
//     { name: "state_id", label: "State", type: "select", dropdownKey: "state_id" },
//     { name: "csc_id", label: "City", type: "select", dropdownKey: "csc_id" },
//     { name: "area_id", label: "Area", type: "select", dropdownKey: "area_id" },
//     {
//       name: "phone_extension",
//       label: "Phone Extension",
//       type: "select",
//       dropdownKey: "phone_extension",
//     },
//     { name: "phone_no", label: "Phone Number", type: "text" },
//     { name: "status_id", label: "Status", type: "select", dropdownKey: "status_id" },
//     { name: "logo", label: "Logo", type: "file", onChange: handleFileChange },
//   ];

//   const columns = [
//     { name: "est_name", label: "Name" },
//     { name: "csc_name", label: "City" },
//     { name: "area_name", label: "Area" },
//     { name: "phone_extension", label: "Phone Extension" },
//     { name: "phone_no", label: "Phone No" },
//     { name: "status_name", label: "Status" },
//     { name: "logo", label: "Logo" },
//   ];

//   return (
//     <div className="establishments">
//       <EntityManagement
//         entityName="Establishment"
//         formFields={formFields}
//         formData={formData}
//         onFileChange={handleFileChange}
//         setFormData={setFormData}
//         handleFormSubmit={handleFormSubmit}
//         dropdownData={dropdownData}
//         setDropdownData={setDropdownData}
//         handleViewTableClick={() => setIsTableModalOpen(true)}
//         firstFormFieldRef={firstFormFieldRef}
//         onEdit={handleEdit}
//       />
//       {isTableModalOpen && (
//         <div className="modal">
//           <div className="modal-content">
//             <button onClick={() => setIsTableModalOpen(false)}>Close</button>
//             <EntityTable
//               data={entities}
//               columns={columns}
//               onEdit={handleEdit}
//               onDelete={handleDelete}
//               keyField="est_id"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Establishments;


import React, { useState, useEffect, useRef } from "react";
import EntityManagement from "../../components/formTemplates/EntityManagement";
import EntityTable from "../../components/templateComponents/EntityTable";
import useDropdownFetch from "../../components/apiFetch/useDropdownFetch";
import axiosInstance from "../../utils/axios";
import { staticPhoneExtensions } from "../templateComponents/constants";

const Establishments = () => {
  const [formData, setFormData] = useState({
    est_name: "",
    country_id: "",
    state_id: "",
    csc_id: "",
    area_id: "",
    phone_extension: "",
    phone_no: "",
    status_id: "",
    logo: null,
  });

  const [formErrors, setFormErrors] = useState({});
  const [entities, setEntities] = useState([]);
  const [dropdownData, setDropdownData] = useState({
    country_id: [],
    state_id: [],
    csc_id: [],
    area_id: [],
    status_id: [],
    phone_extension: staticPhoneExtensions
  });

  const [editMode, setEditMode] = useState(false);
  const [editingEntityId, setEditingEntityId] = useState(null);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);
  const firstFormFieldRef = useRef(null);

  const endpoints = {
    country: "/country/v0.1",
    state: "/state/v0.1",
    csc: "/city/v0.1",
    area: "/area/v0.1",
    status: "/view_status/v0.1",
    viewEstablishments: "/view_establishment/v1.1",
    registerEstablishment: "/registration_establishment/v1.1",
    updateEstablishment: "/update_establishment/v1.1",
  };

  const { options: statusOptions } = useDropdownFetch(endpoints.status);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axiosInstance.get(endpoints.country);
        const formatted = Object.entries(response.data.Data).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, country_id: formatted }));
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      if (!formData.country_id) return;
      try {
        const response = await axiosInstance.post(endpoints.state, { csc_id: formData.country_id });
        const formatted = Object.entries(response.data.Data).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, state_id: formatted }));
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
  }, [formData.country_id]);

  useEffect(() => {
    const fetchCities = async () => {
      if (!formData.state_id) return;
      try {
        const response = await axiosInstance.post(endpoints.csc, {
          csc_id: formData.state_id,
          view_type: "view",
        });
        const formatted = Object.entries(response.data.Data).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, csc_id: formatted }));
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, [formData.state_id]);

  useEffect(() => {
    const fetchAreas = async () => {
      if (!formData.csc_id) return;
      try {
        const response = await axiosInstance.post(endpoints.area, {
          csc_id: formData.csc_id,
          view_type: "view",
        });
        const formatted = Object.entries(response.data.Data).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, area_id: formatted }));
      } catch (error) {
        console.error("Error fetching areas:", error);
      }
    };
    fetchAreas();
  }, [formData.csc_id]);

  useEffect(() => {
    if (statusOptions) {
      setDropdownData((prev) => ({ ...prev, status_id: statusOptions }));
    }
  }, [statusOptions]);

  useEffect(() => {
    const fetchEntities = async () => {
      try {
        const response = await axiosInstance.post(endpoints.viewEstablishments, {
          view_type: "view all",
        });
        setEntities(response.data.Data || []);
      } catch (error) {
        console.error("Error fetching establishments:", error);
      }
    };
    fetchEntities();
  }, [formData.area_id]);

  const validatePhone = (phone) => {
    return /^[0-9]{10}$/.test(phone);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const errors = {};
    if (!validatePhone(formData.phone_no)) {
      errors.phone_no = "Phone number must be 10 digits.";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    } else {
      setFormErrors({});
    }

    const formattedFormData = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== "" && value !== null && value !== undefined) {
        formattedFormData[key] = value;
      }
    });

    ["csc_id", "area_id", "status_id"].forEach((key) => {
      if (formattedFormData[key]) {
        formattedFormData[key] = parseInt(formattedFormData[key], 10);
      }
    });

    delete formattedFormData.country_id;
    delete formattedFormData.state_id;

    try {
      if (editMode) {
        await handleUpdate(editingEntityId, formattedFormData);
      } else {
        let response;
        if (formData.logo) {
          const formDataToSubmit = new FormData();
          for (const key in formattedFormData) {
            formDataToSubmit.append(key, formattedFormData[key]);
          }
          formDataToSubmit.append("logo", formData.logo);
          response = await axiosInstance.post(endpoints.registerEstablishment, formDataToSubmit);
        } else {
          response = await axiosInstance.post(endpoints.registerEstablishment, formattedFormData);
        }
        setEntities([...entities, response.data]);
        resetForm();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleUpdate = async (entityId, updatedData) => {
    try {
      await axiosInstance.post(endpoints.updateEstablishment, {
        est_id: entityId,
        ...updatedData,
      });
      setEntities((prev) =>
        prev.map((entity) =>
          entity.est_id === entityId ? { ...updatedData, est_id: entityId } : entity
        )
      );
      resetForm();
    } catch (error) {
      console.error("Error updating establishment:", error);
    }
  };

  const resetForm = () => {
    setFormData({
      est_name: "",
      country_id: "",
      state_id: "",
      csc_id: "",
      area_id: "",
      phone_extension: "",
      phone_no: "",
      status_id: "",
      logo: null,
    });
    setFormErrors({});
    setEditMode(false);
    setEditingEntityId(null);
  };

  const handleEdit = (entityId) => {
    const entity = entities.find((e) => e.est_id === entityId);
    if (entity) {
      setFormData({
        est_name: entity.est_name,
        csc_id: entity.csc_id,
        area_id: entity.area_id,
        phone_extension: entity.phone_extension,
        phone_no: entity.phone_no,
        status_id: entity.status_id,
        logo: null,
        country_id: "",
        state_id: "",
      });
      setEditMode(true);
      setEditingEntityId(entityId);
      firstFormFieldRef.current?.focus();
      setIsTableModalOpen(false);
    }
  };


  const handleFileChange = (e) => {
    setFormData({ ...formData, logo: e.target.files[0] });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone_no") {
      if (!/^[0-9]{0,10}$/.test(value)) {
        setFormErrors((prev) => ({
          ...prev,
          phone_no: "Phone number must be numeric and up to 10 digits.",
        }));
      } else {
        setFormErrors((prev) => {
          const updated = { ...prev };
          delete updated.phone_no;
          return updated;
        });
      }
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const formFields = [
    { name: "est_name", label: "Establishment Name", type: "text" },
    { name: "country_id", label: "Country", type: "select", dropdownKey: "country_id" },
    { name: "state_id", label: "State", type: "select", dropdownKey: "state_id" },
    { name: "csc_id", label: "City", type: "select", dropdownKey: "csc_id" },
    { name: "area_id", label: "Area", type: "select", dropdownKey: "area_id" },
    {
      name: "phone_extension",
      label: "Phone Extension",
      type: "select",
      dropdownKey: "phone_extension",
    },
    {
      name: "phone_no",
      label: "Phone Number",
      type: "text",
      onChange: handleInputChange,
      error: formErrors.phone_no,
    },
    { name: "status_id", label: "Status", type: "select", dropdownKey: "status_id" },
    { name: "logo", label: "Logo", type: "file", onChange: handleFileChange },
  ];

  const columns = [
    { name: "est_name", label: "Name" },
    { name: "csc_name", label: "City" },
    { name: "area_name", label: "Area" },
    { name: "phone_extension", label: "Phone Extension" },
    { name: "phone_no", label: "Phone No" },
    { name: "status_name", label: "Status" },
    { name: "logo", label: "Logo" },
  ];

  return (
    <div className="establishments">
      <EntityManagement
        entityName="Establishment"
        formFields={formFields}
        formData={formData}
        onFileChange={handleFileChange}
        setFormData={setFormData}
        handleFormSubmit={handleFormSubmit}
        dropdownData={dropdownData}
        setDropdownData={setDropdownData}
        handleViewTableClick={() => setIsTableModalOpen(true)}
        firstFormFieldRef={firstFormFieldRef}
        onEdit={handleEdit}
        formErrors={formErrors}
      />
      {isTableModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <button onClick={() => setIsTableModalOpen(false)}>Close</button>
            <EntityTable
              data={entities}
              columns={columns}
              onEdit={handleEdit}
              keyField="est_id"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Establishments;
